import { render, staticRenderFns } from "./ComplianceDeclarations-Profile.vue?vue&type=template&id=48f9ee6c"
import script from "./ComplianceDeclarations-Profile.vue?vue&type=script&lang=js"
export * from "./ComplianceDeclarations-Profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports